import modelExtend from 'dva-model-extend'
import { basicModel, UPDATESTATE } from '@sisyphe/utils'
import * as api from 'services/store'

export default modelExtend(basicModel, {
  namespace: 'cart',
  state: {
    amount: 0,
  },
  reducers: {},
  effects: {
    /** 购物车管理-购物车数量 */
    *getShopCartNum({ payload }, { call, put }) {
      const { data } = yield call(api.shopCartNumUsingPOST, payload)
      yield put({
        type: UPDATESTATE,
        payload: {
          amount: data,
        },
      })
      return data
    },
  },
})
